import React from "react";
import ReactMarkdown from "react-markdown";

export default function MarkdownBody({ children, testid = "markdown-body" }) {
  return (
    <div
      data-testid={testid}
      className="prose-shutterkart max-w-none text-[#1A1A1A]/85"
    >
      <ReactMarkdown
        components={{
          h1: ({ node, ...props }) => (
            <h1
              {...props}
              className="mt-2 font-display text-3xl text-[#1A1A1A] sm:text-4xl"
            />
          ),
          h2: ({ node, ...props }) => (
            <h2
              {...props}
              className="mt-8 font-display text-2xl text-[#1A1A1A]"
            />
          ),
          h3: ({ node, ...props }) => (
            <h3
              {...props}
              className="mt-6 font-display text-xl text-[#1A1A1A]"
            />
          ),
          p: ({ node, ...props }) => (
            <p {...props} className="mt-4 text-base leading-relaxed" />
          ),
          ul: ({ node, ...props }) => (
            <ul {...props} className="mt-4 list-disc space-y-1 pl-6" />
          ),
          a: ({ node, ...props }) => (
            <a {...props} className="text-[#C8A24B] underline-offset-4 hover:underline" />
          ),
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
